<template>
  <div class="main">
    <div class="top">
      <img src="../../assets/img/normal.jpg" />
    </div>
    <div class="info">
      <div class="title">{{ hospitalInfo.name }}</div>
      <img :src="hospitalInfo.expertUrl"  />
      <div class="title">识别二维码添加专属助手</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'uniapp-doctorGroup',
  data() {
    return {
      hospitalId: '',
      hospitalInfo: {}
    }
  },
  mounted() {
    this.hospitalId = this.$route.query.hospitalId || '';
    this.onGetHospitalInfo();
  },
  methods: {
    async onGetHospitalInfo() {
      const auth = this.$createAuth(this.$md5);
      const result = await this.$http.get(this.$url.getHospitalInfo, {
        hospitalId: this.hospitalId,
        auth: auth.code,
        time: auth.time
      });
      this.hospitalInfo = result.data.hospitalInfo;
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  width: 100vw;
  height: 100vh;
  background: #f4f4f4;

  .top {
    width: 100%;
    background: #fff;

    img {
      width: 100vw;
      height: 51vw;
    }
  }

  .info {
    position: absolute;
    top: 40vw;
    left: 12.5vw;
    width: 75vw;
    height: 90vw;
    padding: 0.3rem;
    text-align: center;
    background: #fff;
    border-radius: 0.1rem;
    box-sizing: border-box;

    .title {
      padding-bottom: 0.3rem;
      text-align: center;
    }

    img {
      width: 55vw;
      height: 55vw;
      margin: 0.2rem 0;
      padding: 0.1rem;
      border: 0.01rem solid #42b983;
      border-radius: 0.05rem;
    }
  }
}
</style>